import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToasterService } from '../../../toaster/toaster.service';
import { AuthenticationService } from '../../../auth/authentication.service';

@Component({
  selector: 'app-change-password-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './change-password-form.component.html',
  styleUrl: './change-password-form.component.scss'
})
export class ChangePasswordFormComponent implements OnInit {

  @Output()
  backHome = new EventEmitter();

  changePasswordForm!: FormGroup;
  validityModel: any = {

  };

  constructor(private fb: FormBuilder, private toasterService: ToasterService, private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.changePasswordForm = this.fb.group({
      newPassword: this.fb.control('', [Validators.required]),
      confirmPassword: this.fb.control('', [Validators.required]),
    });

    this.changePasswordForm.valueChanges.subscribe(() => {
      this.validityModel = this.isPasswordValid();
    });
  }

  returnHome() {
    this.backHome.emit(true);
  }

  changePassword() {
    if (this.changePasswordForm?.valid && this.arePasswordsTheSame() && this.isPasswordValid().allValid) {
      this.authService.changePassword(this.changePasswordForm?.value.newPassword).subscribe(a => {
        this.toasterService.show({
          text: 'Password changed successfully',
          classname: 'bg-success text-light',
          delay: 5000
        });
        this.backHome.emit(true);
      });
    }
  }

  arePasswordsTheSame() {
    return this.changePasswordForm?.value.newPassword === this.changePasswordForm?.value.confirmPassword;
  }

  isPasswordValid() {
    const password = this.changePasswordForm?.value.newPassword;

    if (!password) {
      return {
        isValidLength: false,
        hasLowercase: false,
        hasUppercase: false,
        hasNumerical: false,
        hasSpecial: false,
        allValid: false
      }
    }

    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const numericalRegex = /[0-9]/;
    const specialRegex = /[!@#$%^&*()_<>,.:+=\-?{};`~[/\]]/;

    const isValidLength = password.length >= 8;
    const hasLowercase = lowercaseRegex.test(password);
    const hasUppercase = uppercaseRegex.test(password);
    const hasNumerical = numericalRegex.test(password);
    const hasSpecial = specialRegex.test(password);

    const validityModel = {
      isValidLength: isValidLength,
      hasLowercase: hasLowercase,
      hasUppercase: hasUppercase,
      hasNumerical: hasNumerical,
      hasSpecial: hasSpecial,
      allValid: hasLowercase && hasUppercase && hasNumerical && hasSpecial && isValidLength
    };

    return validityModel;
  }
}
